<ms-my-bets-print-title></ms-my-bets-print-title>
<div class="my-bets-print-header-username" [hidden]="isEpcotEnabled">
    <span>{{ UserName }}</span>
    <span>{{ sitecore.myBets_Print.UserId }}: {{ userID }}</span>
</div>

<div class="popup-body cards mybetscontent">
    <div id="betslips-list-wrapper">
        <div id="{{ betslip.betslipId }}" class="my-bets-list-betslip-container" *ngFor="let betslip of betslips; let first = first">
            <ms-my-bets-edit-bet-history-betslip
                [betslip]="betslip"
                [myBetsListContext]="myBetsListContext"
                [isFirst]="first"></ms-my-bets-edit-bet-history-betslip>
        </div>
    </div>
</div>
